<template>
  <div id="app" class="text-gray-800 font-sans">
    <div class="min-h-screen h-screen flex overflow-hidden">
      <div
        class="max-w-xs w-full flex-shrink-0 bg-ilift-secondary-500 min-h-full text-white overflow-y-auto"
      >
        <div class="p-6 space-y-4">
          <div>
            <h1 class="uppercase text-3xl font-semibold text-ilift-600">
              <!-- <img
                class="w-48"
                src="@/assets/images/Logo_white.png"
                alt="ilift"
              /> -->
              iLift
            </h1>
            <p class="text-xs uppercase tracking-wide font-semibold text-white">
              {{ roleName }}
            </p>
          </div>

          <hr class="border-gray-700" />

          <div>
            <ul class="font-semibold text-sm tracking-wide space-y-2">
              <li v-for="nav in navs" :key="nav.url">
                <router-link
                  class="flex items-center px-2 py-3 rounded hover:bg-ilift-secondary-400"
                  :to="nav.url"
                >
                  <i class="material-icons mr-2">{{ nav.icon }}</i>
                  {{ nav.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex-1 flex flex-col bg-ilift-secondary-100 overflow-y-auto">
        <div class="bg-white shadow px-6 py-4 z-30">
          <div class="flex justify-between items-center">
            <div
              class="flex items-center space-x-2 uppercase text-gray-600 font-semibold tracking-wide text-sm"
            >
              <div v-for="(path, index) in paths" :key="path.path">
                <span v-if="index" class="mr-2">/</span>
                <span v-if="path.current">{{ path.text || path.path }}</span>
                <router-link
                  v-else
                  :to="path.to"
                  class="hover:text-gray-800 hover:underline"
                >
                  {{ path.text || path.path }}
                </router-link>
              </div>
            </div>
            <div
              @click="dropdown = !dropdown"
              class="flex items-center space-x-2 relative cursor-pointer"
            >
              <span>{{ name }}</span>
              <div
                class="h-10 w-10 rounded-full bg-indigo-700 border-2 border-gray-500"
              ></div>
              <transition>
                <div
                  v-if="dropdown"
                  class="absolute right-0 top-0 mt-12 shadow-lg bg-white w-56 border rounded"
                >
                  <button
                    v-if="roles.length > 0"
                    @click.stop="changeRole"
                    type="button"
                    class="block w-full text-left px-6 py-3 hover:bg-gray-200 outline-none active:outline-none"
                  >
                    Change Role
                  </button>
                  <button
                    @click.stop="logout"
                    type="button"
                    class="block w-full text-left px-6 py-3 hover:bg-gray-200 outline-none active:outline-none"
                  >
                    Logout
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <router-view />
        </div>
      </div>
    </div>

    <portal-target name="modals"></portal-target>
  </div>
</template>

<script>
import { roles } from "../config";
export default {
  data() {
    return {
      dropdown: false,
      allNavs: [
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: "dashboard",
          roles: [1]
        },
        {
          title: "Accounts",
          url: "/accounts",
          icon: "dashboard",
          roles: [1]
        },
        {
          title: "Corporate Dashboard",
          url: "/corporate/dashboard",
          icon: "dashboard",
          roles: [4]
        },
        {
          title: "Tickets",
          url: "/corporate/tickets",
          icon: "receipt",
          roles: [4]
        },
        {
          title: "Employees",
          url: "/corporate/employees",
          icon: "receipt",
          roles: [4]
        },
        {
          title: "Corporate Management",
          url: "/corporate",
          icon: "domain",
          roles: [1, 3]
        },
        {
          title: "Riders",
          url: "/riders",
          icon: "directions_walk",
          roles: [1, 2]
        },
        {
          title: "Drivers",
          url: "/drivers",
          icon: "people_alt",
          roles: [1, 2]
        },
        {
          title: "Rides",
          url: "/rides",
          icon: "electric_car",
          roles: [1, 2]
        },
        {
          title: "Manual Ride Booking",
          url: "/manual-ride-booking",
          icon: "edit_road",
          roles: [1, 2]
        },
        {
          title: "Wallet Managment",
          url: "/wallet-managment",
          icon: "account_balance_wallet",
          roles: [1]
        },
        {
          title: "Loan History",
          url: "/loan-history",
          icon: "account_balance_wallet",
          roles: [1, 3]
        },
        {
          title: "Vehicle Type",
          url: "/vehicle-types",
          icon: "commute",
          roles: [1]
        },
        {
          title: "Vehicles",
          url: "/vehicles",
          icon: "directions_car",
          roles: [1]
        },
        // {
        //   title: "Payment Records",
        //   url: "/payment-records",
        //   icon: "money",
        //   roles: [1, 3],
        // },
        // {
        //   title: "Reviews & Ratings",
        //   url: "/reviews-and-ratings",
        //   icon: "stars",
        //   roles: [1],
        // },
        {
          title: "God's View Location",
          url: "/gods-view",
          icon: "gps_fixed",
          roles: [1, 2]
        },
        {
          title: "SOS",
          url: "/sos",
          icon: "announcement",
          roles: [1, 2]
        },
        {
          title: "SOSHistory",
          url: "/sos-history",
          icon: "announcement",
          roles: [1, 2]
        },
        {
          title: "FQA",
          url: "/fqa",
          icon: "announcement",
          roles: [1, 2, 3]
        },
        {
          title: "Finance",
          url: "/finance",
          icon: "calculate",
          roles: [1, 3]
        },
        {
          title: "Push Notification",
          url: "/push-notification",
          icon: "notifications_active",
          roles: [1]
        },
        {
          title: "Site Setting",
          url: "/setting",
          icon: "settings",
          roles: [1]
        },
        {
          title: "Logs",
          url: "/logs",
          icon: "article",
          roles: [1]
        }
      ],
      paths: []
    };
  },
  watch: {
    $route(to) {
      let pathArray = to.path.split("/");

      pathArray.shift();

      this.paths = pathArray.map((path, index) => {
        return {
          path: path,
          to: index > 0 ? "/" + pathArray[index - 1] + "/" + path : "/" + path,
          text: to.matched[index] ? to.matched[index].name : "magic",
          current:
            pathArray.length < 1 || pathArray[pathArray.length - 1] === path
        };
      });
    }
  },
  computed: {
    roleName() {
      return roles[this.role];
    },
    roles() {
      return this.$store.getters.isLoggedIn
        ? this.$store.state.auth.account.roles
        : [];
    },
    role() {
      return this.$store.getters.isLoggedIn && this.$store.getters.hasRole
        ? this.$store.state.role
        : null;
    },
    navs() {
      return this.allNavs.filter(nav => nav.roles.includes(this.role));
    },
    name() {
      if (!this.$store.getters.isLoggedIn) return null;

      const auth = this.$store.state.auth.account;
      return `${auth.firstName} ${auth.lastName}`;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").finally(() => this.$router.push("/login"));
    },
    changeRole() {
      this.$router.push("/role");
    }
  }
};
</script>
